// Below-fold only. No cart, analytics, storage, URL or network side effects.
if (!customElements.get('cx-pdp-motion')) {
  customElements.define('cx-pdp-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.userPaused = false;
      this.userStarted = false;
      this.button.hidden = false;
      if (this.video) {
        this.video.controls = false;
        this.video.muted = true;
        this.video.addEventListener('play', () => this.reflect(true), options);
        this.video.addEventListener('pause', () => this.reflect(false), options);
      }
      this.button.addEventListener('click', () => {
        if (this.hasAttribute('data-running')) {
          this.userPaused = true;
          this.userStarted = false;
        } else {
          this.userPaused = false;
          this.userStarted = true;
        }
        this.update();
      }, options);
      this.motion.addEventListener('change', () => {
        this.userStarted = false;
        this.update();
      }, options);
      document.addEventListener('visibilitychange', () => this.update(), options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.update();
      }, {threshold: 0.15});
      this.observer.observe(this);
      this.setAttribute('data-ready', '');
      this.update();
    }
    reflect(running) {
      this.toggleAttribute('data-running', running);
      this.button.setAttribute('aria-label', running ? this.dataset.pause : this.dataset.play);
    }
    update() {
      const running = this.visible && !document.hidden && !this.userPaused &&
        (!this.motion.matches || (this.video && this.userStarted));
      if (this.video) {
        if (running) this.video.play().catch(() => this.reflect(false));
        else this.video.pause();
      } else {
        this.button.hidden = this.motion.matches;
      }
      this.reflect(Boolean(running));
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.video?.pause();
      this.abort = null;
    }
  });
}
